module.exports = __webpack_public_path__ + "img/search_icon.592bd0e8.svg";